import React, { useEffect, useMemo, useState } from 'react';

import * as S from './styles';

const PlusInfinitySymbol = '\u221e';

type Props = {
  min: number;
  max: number;
  steps: number;
  data: number;
  setData: React.Dispatch<React.SetStateAction<number>>;
};

const InputRange = ({ min, max, steps, data, setData }: Props) => {
  const [inputValue, setInputValue] = useState(0);

  useEffect(() => {
    setInputValue(data);
  }, [data]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.valueAsNumber;
    setInputValue(value);
    setData(value);
  };

  const formattedValue = useMemo(() => {
    if (inputValue !== 0) {
      if (inputValue === -1 || inputValue === 1) {
        return `á ${inputValue} dia`;
      }
      if (inputValue === -6) {
        return `á -infinitos dias`;
      }
      if (inputValue === 11) {
        return `á infinitos dias`;
      }

      return `á ${inputValue} dias`;
    }

    return `${inputValue}`;
  }, [inputValue]);

  return (
    <S.Container>
      <S.ValueDisplay>Deadline próxima {formattedValue}</S.ValueDisplay>
      <S.InputContainer>
        <S.InfinityIconContainer>-{PlusInfinitySymbol}</S.InfinityIconContainer>
        <output>0</output>
        <S.InfinityIconContainer>{PlusInfinitySymbol}</S.InfinityIconContainer>
      </S.InputContainer>

      <S.RangeInput
        type="range"
        min={min}
        max={max}
        step={steps}
        value={inputValue}
        onChange={handleChange}
      />
    </S.Container>
  );
};

export default InputRange;
